import React from "react";
import { Form, NavDropdown } from "react-bootstrap";
import { IoIosSearch } from "react-icons/io";

import AddButton from "./AddButton";
import { PALETTE } from "../ThemeConstants";
import UserAvatar from "./UserAvatar";
import SignedCard from "../../account/components/SignedCard";
import { useAuth } from "../../auth/hook";

export default function SearchBar({
  placeholder = "Cerca",
  addButton,
  onAdd,
  onChange,
  avatar,
  disabled = false,
}) {
  const auth = useAuth();
  const user = auth.user;
  const role = auth.role;
  const cover = user.cover ? user.cover : undefined;
  return (
    <div>
      <Form className="d-flex" style={{ marginBottom: 0 }}>
        <div
          className="align-self-center text-center p-2"
          style={{
            backgroundColor: PALETTE.KINDALIGHTGRAY,
            borderBottomLeftRadius: "10px",
            borderTopLeftRadius: "10px",
            borderBottomRightRadius: "0px",
            borderTopRightRadius: "0px",
          }}
        >
          <IoIosSearch size={24} color={PALETTE.GRAY} />
        </div>
        <Form.Control
          type="search"
          placeholder={placeholder}
          style={{
            borderLeft: "none",
            borderTop: "none",
            borderRight: "none",
            borderBottom: "none",
            backgroundColor: PALETTE.KINDALIGHTGRAY,
            borderBottomLeftRadius: "0px",
            borderTopLeftRadius: "0px",
            borderBottomRightRadius: addButton ? "0px" : "10px",
            borderTopRightRadius: addButton ? "0px" : "10px",
            boxShadow: "none",
          }}
          aria-label="Search"
          onChange={(event) => {
            onChange(event.target.value);
          }}
          disabled={disabled}
        />
        {addButton && (
          <AddButton
            size={24}
            onClick={() => {
              onAdd();
            }}
            color={PALETTE.GRAY}
            roundedBottomRight={10}
            roundedTopRight={10}
          />
        )}
        {avatar && (
          <div
            className="align-self-center justify-content-end"
            style={{ display: "flex", paddingLeft: 4 }}
          >
            <NavDropdown
              align={{ lg: "start" }}
              className="align-self-center"
              drop="start"
              title={
                <div className="m-0 align-self-center text-center">
                  <UserAvatar
                    firstname={user.firstname}
                    lastname={user.lastname}
                    size={37}
                    fontSize={14}
                    shadow={false}
                    background={PALETTE.KINDALIGHTGRAY}
                    color={PALETTE.DARKGRAY}
                    hoverable={true}
                    cover={cover}
                    borderColor={PALETTE.WHITE}
                  />
                </div>
              }
              id="nav-dropdown"
            >
              <SignedCard user={user} role={role} onSignOut={auth.logOut} />
            </NavDropdown>
          </div>
        )}
      </Form>
    </div>
  );
}
